import { render, staticRenderFns } from "./Tpls.vue?vue&type=template&id=46bb4d72"
import script from "./Tpls.vue?vue&type=script&lang=js"
export * from "./Tpls.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports